import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'error-message-display',
  styleUrl: 'error-message-display.css',
})
export class ErrorMessageDisplay {
  @Prop() errorMessage: string = '';
  render() {
    return (
      <div class="error-container">
        <div class="error-header mx-auto my-1 w-4 h-4">
          <icon-alert />
        </div>
        <ul class="p-0 list-none w-fit mx-auto">
          {this.errorMessage &&
            this.errorMessage
              .split('.')
              .slice(0, -1)
              .map((text) => <li class="text-left">{`${text}.`}</li>)}
        </ul>
      </div>
    );
  }
}
